import React from 'react';

export interface FacebookProps {
  className?: string;
}

const WeatherCloudy: React.FC<FacebookProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 4C11.0523 4 11.5 4.44772 11.5 5V6.07643C12.5489 6.23835 13.5148 6.651 14.3347 7.25113L15.2929 6.29289C15.6834 5.90237 16.3166 5.90237 16.7071 6.29289C17.0976 6.68342 17.0976 7.31658 16.7071 7.70711L15.7487 8.66548C15.8424 8.7935 15.9315 8.92506 16.0158 9.05994C16.3383 9.02038 16.6668 9 17 9C20.5864 9 23.6195 11.3591 24.6363 14.609C26.6271 15.5843 28 17.6307 28 20C28 23.3137 25.3137 26 22 26H7C4.23858 26 2 23.7614 2 21C2 18.8575 3.34683 17.0312 5.23975 16.319C4.64619 15.5025 4.2376 14.5419 4.07655 13.5H3C2.44772 13.5 2 13.0523 2 12.5C2 11.9477 2.44772 11.5 3 11.5H4.07645C4.23838 10.4513 4.65097 9.48537 5.2511 8.66531L4.29289 7.70711C3.90237 7.31658 3.90237 6.68342 4.29289 6.29289C4.68342 5.90237 5.31658 5.90237 5.70711 6.29289L6.66531 7.2511C7.48537 6.65097 8.45131 6.23838 9.5 6.07645V5C9.5 4.44772 9.94772 4 10.5 4ZM10.5 8C8.01472 8 6 10.0147 6 12.5C6 13.2863 6.20111 14.0247 6.55526 14.6676C7.45877 13.7376 8.68843 13.1257 10.0605 13.0173C10.9375 11.4924 12.3033 10.2831 13.9448 9.60416C13.119 8.62308 11.8817 8 10.5 8ZM17 11C14.6069 11 12.5391 12.4009 11.5756 14.4319C11.4042 14.7931 11.0341 15.0175 10.6345 15.0025C10.5899 15.0008 10.5451 15 10.5 15C8.95622 15 7.64343 16.0001 7.17919 17.3906C7.06503 17.7325 6.7757 17.9865 6.42189 18.0555C5.04161 18.3244 4 19.5416 4 21C4 22.6569 5.34315 24 7 24H22C24.2091 24 26 22.2091 26 20C26 18.3002 24.9394 16.8457 23.4403 16.2669C23.135 16.149 22.9067 15.8891 22.8291 15.5712C22.1884 12.9468 19.8203 11 17 11Z"
        fill="white"
      />
    </svg>
  );
};

export default WeatherCloudy;
